import WCrossedOut from './crossed-out.vue';
import WSimple from './simple.vue';
import WText from './text.vue';
import WRow from './row.vue';

// UWAGA: koniecznie zaktualizaować również previewComponentsList.js - listę komponentów do buildera
export const components = {
  WSimple,
  WText,
  WRow,
  WCrossedOut
};

export function registerPreviewComponents(Vue, registerLog) {
  for (var name in components) {
    if (registerLog) {
      console.time('register ' + name);
      Vue.component(name, components[name]);
      console.timeEnd('register ' + name);
    } else {
      Vue.component(name, components[name]);
    }

  }
}


export default components;
